import { LinearProgress } from "@octopusdeploy/design-system-components";
import type { UnknownQueryParam } from "@octopusdeploy/portal-routes";
import { useQueryStringParams } from "@octopusdeploy/portal-routes";
import React from "react";
import { Route, useParams } from "react-router-dom";
import { AsyncInternalRedirect } from "~/routing/AsyncInternalRedirect";
import { legacySpaceRouteRegistrations, legacySystemOrMixedScopeRouteRegistrations } from "~/routing/legacyRouteRegistrations/allLegacyRouteRegistrations";
import type { LegacyRouteRegistration } from "~/routing/legacyRouteRegistrations/createLegacyRouteRegistrations";
import { formatRoutePath } from "~/routing/pageRegistrations/formatRoutePath";
export function allLegacySystemOrMixedScopeRedirectRoutes() {
    const registrations: UnknownLegacyRouteRegistration[] = Object.values(legacySystemOrMixedScopeRouteRegistrations);
    return registrations.map(createLegacyRouteComponent);
}
export function allLegacySpaceRedirectRoutes() {
    const registrations: UnknownLegacyRouteRegistration[] = Object.values(legacySpaceRouteRegistrations);
    return registrations.map(createLegacyRouteComponent);
}
export function createLegacyRouteComponent<RouteParams, QueryParams extends UnknownQueryParam[]>(legacyRouteRegistration: LegacyRouteRegistration<RouteParams, QueryParams>) {
    return <Route key={legacyRouteRegistration.route.getDebugString()} path={formatRoutePath(legacyRouteRegistration.route.relativeTemplate)} element={<LegacyRoute routeRegistration={legacyRouteRegistration}/>}/>;
}
function LegacyRoute<RouteParams, QueryParams extends UnknownQueryParam[]>({ routeRegistration }: {
    routeRegistration: LegacyRouteRegistration<RouteParams, QueryParams>;
}) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const routeParams: RouteParams = useParams() as RouteParams;
    const [queryParams] = useQueryStringParams<QueryParams>(routeRegistration.route.queryParameters);
    return <AsyncInternalRedirect loader={() => routeRegistration.redirect(routeParams, queryParams)} renderWhenLoading={<LinearProgress variant={"indeterminate"} show={true}/>}/>;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UnknownLegacyRouteRegistration = LegacyRouteRegistration<any, UnknownQueryParam[]>;
